import React from 'react'
import { Link } from 'gatsby'
import { Button } from 'reactstrap'
import headerStyles from './header.module.css'
import SelectLanguage from '../SelectLanguage'


const Header = props => (
  <div className={headerStyles.wrapper}>
    <div className={headerStyles.container}>
      <ul className={headerStyles.siteTabs}>
        <li>
          <a href="http://www.crea.ca/">CREA</a>
        </li>
        <li>
          <a href="https://www.creacafe.ca/">CREA CAFÉ</a>
        </li>
        <li>
          <a href="https://www.realtorscare.ca/">
            REALTORS CARE<sup>®</sup>
          </a>
        </li>
        <li>
          <a className={headerStyles.activeNav} href="/">
            CREA STATS
          </a>
        </li>
        <li>
          <a href="https://www.realtor.ca/" target="_blank">
            REALTOR.ca
          </a>
        </li>
      </ul>

      <ul className={headerStyles.utilityNav}>
        <li>
          <a href="http://www.crea.ca/">Home</a>
        </li>
        <li>
          <a href="http://www.realtorlink.ca/" target="_blank">
            Member Login
          </a>
        </li>
        <li>
          <a href="https://www.crea.ca/newsroom/">Newsroom</a>
        </li>
        <li>
          <a href="https://www.crea.ca/about/careers/">Careers</a>
        </li>
        <li>
          <a href="https://www.crea.ca/contact/">Contact</a>
        </li>
      </ul>
    </div>
  </div>
)

export default Header
